import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Container } from '@sm/wds-react';
import { createSurveyStyles, useSurveyTheme, Helmet } from '@sm/webassets';
import { PageVariants, EnterpriseThankYouContext } from '~app/pages/EnterpriseThankYou';
import getSpageGoogleFontsLink from '~app/helpers/spageGoogleFonts';

const useStyles = createSurveyStyles(theme => {
  return {
    background: {
      background: theme?.primaryBackgroundColor,
    },
  };
});

const EnterpriseThankYouLayout = ({ children }) => {
  const { pageVariant } = useContext(EnterpriseThankYouContext);
  const premiumCustom = pageVariant === PageVariants.premiumCustom;
  const { background } = useStyles();
  const theme = useSurveyTheme();
  const spageGoogleFontsLink = getSpageGoogleFontsLink(theme);

  return (
    <Container className={`background-wrapper ${premiumCustom ? background : ''}`}>
      <Helmet>
        <If condition={premiumCustom && spageGoogleFontsLink}>
          <link rel="stylesheet" href={spageGoogleFontsLink} async />
        </If>
      </Helmet>
      {children}
    </Container>
  );
};

EnterpriseThankYouLayout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default EnterpriseThankYouLayout;
